import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK,
  CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES,
  CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY,
  CUSTOMERS_FEEDBACK_SET_RECEIPT,
  CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE,
  CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE
} from 'actions/customers/feedback/constants'

let initialState = {
  feedbacks: {
    results: [],
    total_count: 0,
    total_pages: 0
  },
  feedbackMessages: {
    business_logo_url: '',
    business_name: '',
    customer_email: '',
    customer_name: '',
    messages: []
  },
  feedbackData: {
    comment: '',
    feedback_id: 0
  },
  transactionDetail: null,
  currentPage: null,
  totalPage: null
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  switch (action.type) {
    case CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK:
      return {...state, feedbacks: payload.feedbacks}
    case CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES:
      return {...state, feedbackMessages: payload.feedbackMessages}
    case CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY:
      return {...state, feedbackData: payload.feedbackData}
    case CUSTOMERS_FEEDBACK_SET_RECEIPT:
      return {...state, transactionDetail: payload.transactionDetail}
    case CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/customers/feedback.js